export const langCodes = {
  en_US: 'en-US',
  en_CA: 'en-CA',
  en_AU: 'en-AU',
} as const
